export default __webpack_public_path__ + "static/media/typelocation.884a9fc5.svg";